import React from "react";
import { toast } from "sonner";
import { Wallet } from "lucide-react";
import { api } from "../lib/api";
import { euro } from "../lib/format";
import { Switch } from "./ui/switch";

export default function PaymentControls({ quoteId, info, currency = "EUR", onChange }) {
  const bal = info.balance || {};
  const depPaid = info.stato_pagamento_acconto === "pagato";
  const saldoPaid = info.stato_pagamento_saldo === "pagato";

  const toggle = async (kind, paid) => {
    try {
      const { data } = await api.post(`/quotes/${quoteId}/confirm-deposit`, { kind, paid });
      onChange(data);
      toast.success(`${kind === "saldo" ? "Saldo" : "Acconto"} ${paid ? "segnato come incassato" : "segnato come non incassato"}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Aggiornamento non riuscito");
    }
  };

  return (
    <div data-testid="payment-controls" className="bg-card border border-slate-200/80 rounded-xl p-6 shadow-sm">
      <h2 className="text-base font-semibold text-slate-900 flex items-center gap-2 mb-1">
        <Wallet style={{ width: 18, height: 18 }} className="text-primary" /> Incassi: Acconto e Saldo
      </h2>
      <p className="text-sm text-slate-500 mb-4">Segna manualmente gli incassi di acconto e saldo.</p>
      <div className="grid sm:grid-cols-2 gap-3 mb-4">
        <label className="flex items-center justify-between gap-3 rounded-lg border border-border p-3">
          <span className="text-sm">
            <span className="font-medium text-slate-900 block">Acconto incassato</span>
            <span className="text-slate-500 font-mono">{euro(info.deposit?.amount || 0, currency)}</span>
          </span>
          <Switch data-testid="toggle-deposit-paid" checked={depPaid} onCheckedChange={(v) => toggle("acconto", v)} />
        </label>
        <label className="flex items-center justify-between gap-3 rounded-lg border border-border p-3">
          <span className="text-sm">
            <span className="font-medium text-slate-900 block">Saldo incassato</span>
            <span className="text-slate-500 font-mono">{euro(bal.amount || 0, currency)}</span>
          </span>
          <Switch data-testid="toggle-balance-paid" checked={saldoPaid} onCheckedChange={(v) => toggle("saldo", v)} />
        </label>
      </div>
      <div className="text-sm divide-y divide-slate-100 rounded-lg border border-slate-200 px-4">
        <div className="flex justify-between py-2"><span className="text-slate-500">Totale Preventivo</span><span data-testid="pc-total" className="font-mono font-semibold">{euro(bal.total || 0, currency)}</span></div>
        <div className="flex justify-between py-2"><span className="text-emerald-700">Acconto Versato</span><span data-testid="pc-deposit-paid" className="font-mono font-semibold text-emerald-600">− {euro(bal.deposit_paid_amount || 0, currency)}</span></div>
        <div className="flex justify-between py-2"><span className="font-bold text-slate-900">Saldo Residuo</span><span data-testid="pc-residual" className="font-mono font-extrabold">{saldoPaid ? "Pagato" : euro(bal.amount || 0, currency)}</span></div>
      </div>
    </div>
  );
}
